<template>
  <QuickAccessSkeleton v-if="loading" />
  <div v-else class="card-content">
    <a
      v-for="(item, index) in cardItems"
      :key="index"
      :href="item.href"
      :target="item.target"
      class="card-item"
    >
      <div class="icon-wrapper">
        <div v-if="item.notification" class="notification"><span class="notification-text">{{item.notification}}</span></div>
        <img class="card-item-icon" :src="item.icon" alt="acil" />
      </div>
      <span v-html="item.label"></span>
    </a>
  </div>
</template>

<script>
import QuickAccessSkeleton from '@/components/QuickAccess/QuickAccessSkeleton';
import storeIcon from '@/assets/images/icons/store-primary.svg';
import contractIcon from '@/assets/images/icons/contract-primary.svg';
import listIcon from '@/assets/images/icons/list-primary.svg';
import actionsIcon from '@/assets/images/icons/actions-primary.svg';
import viewIcon from '@/assets/images/icons/view-primary.svg';
import eCommerceIcon from '@/assets/images/icons/e-commerce-primary.svg';

export default {
  name: 'QuickAccess',
  components: {
    QuickAccessSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
    },
    cardItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

.card-content {
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 26px;
  flex-wrap: nowrap;

  .card-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 16px;
    max-width: 127px;
    width: 100%;

    .icon-wrapper {
      position: relative;
      display: inline-block;
    }

    .card-item-icon {
      min-width: 36px;
      width: 48px;
      height: 100%;
      padding: 12px;
      background: $colorN10;
      border-radius: 9999px;
    }

    .notification {
      position: absolute;
      top: 5px;
      right: 5px;
      transform: translate(50%, -50%);
      min-width: 16px;
      min-height: 16px;
      background-color: $colorL50;
      border-radius: 8px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .notification-text {
      color: $colorN80;
      font-size: 10px;
      font-weight: 700;
      line-height: 1;
      text-align: center;
      padding: 2px 4px;
    }
  }
}

</style>
